import {
  AgreedToTerms, AlreadyLoggedInGuard, AuthGuard, MustBeDistributor, PreloadRelationships, RedirectToOrdersIfCustomerGuard, UserCanAdmin
} from "./auth.guard";
import { AdminToolsComponent } from "./components/admin-tools/admin-tools.component";
import { HomeComponent } from "./components/home/home.component";
import { PageLoginCognitoComponent } from "./components/page-login-cognito/page-login-cognito.component";
import { PageLoginComponent } from "./components/page-login/page-login.component";
import { PortalShellComponent } from "./components/portal-shell/portal-shell.component";
import { ProfileShellProfileTabComponent } from "./components/profile-shell-profile-tab/profile-shell-profile-tab.component";
import { ProfileShellUsersTabComponent } from "./components/profile-shell-users-tab/profile-shell-users-tab.component";
import { ProfileShellComponent } from "./components/profile-shell/profile-shell.component";
import { TermsAndConditionsComponent } from "./components/terms-and-conditions/terms-and-conditions.component";
import { UserManagementComponent } from "./components/user-management/user-management.component";
import { PageCommunicationsComponent } from "./pages/communications";
import { PageCompaniesComponent } from "./pages/companies";
import { PageCustomerProfileComponent } from "./pages/customerProfile";
import { DigitizationRootComponent } from "./pages/digitization";
import { PageIncashComponent } from "./pages/incash";
import { PageRecsComponent } from "./pages/inmatch";
import { PageInvoiceComponent } from "./pages/invoices";
import { PageOrdersComponent } from "./pages/orders";
import { PageRelationshipsComponent } from "./pages/realationships";
import { PageUserPermissionsComponent } from "./pages/userPermissions";

import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { IFrameComponent } from "./components/iframe.component";
import { PageBusinessIntelligenceComponent } from "./pages/business-intelligence";
import { LandingPageComponent } from "./pages/landing";
import { UserResolver } from "./services/user-resolver";


const routes: Routes = [
  {
    path: "",
    component: HomeComponent
  },
  {
    path: "login",
    component: PageLoginComponent,
    canActivate: [AlreadyLoggedInGuard]
  },
  {
    path: "login-cognito",
    component: PageLoginCognitoComponent,
    canActivate: [AlreadyLoggedInGuard]
  },
  {
    path: "terms",
    component: PortalShellComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        component: TermsAndConditionsComponent
      }
    ]
  },
  {
    path: "admin_tools",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms, PreloadRelationships],
    children: [
      {
        path: "",
        component: AdminToolsComponent
      }
    ]
  },
  {
    path: "admin_tools/:type",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms, PreloadRelationships],
    children: [
      {
        path: "",
        component: AdminToolsComponent
      }
    ]
  },
  {
    path: "users",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms],
    children: [
      {
        path: "",
        component: UserManagementComponent
      }
    ]
  },
  {
    path: "users/:type",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms],
    children: [
      {
        path: "",
        component: UserManagementComponent
      }
    ]
  },
  {
    path: "orders",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms, PreloadRelationships],
    children: [
      {
        path: "**",
        component: PageOrdersComponent
      }
    ]
  },
  {
    path: 'iframe',
    component: PortalShellComponent,
    children: [{
      path: '',
      component: IFrameComponent,
      data: {
        appName: 'inmatch'
      }
    }]
  },
  {
    path: "inmatch",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms, PreloadRelationships],
    children: [
      {
        path: "**",
        component: PageRecsComponent
      }
    ]
  },
  {
    path: "home",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms, PreloadRelationships, RedirectToOrdersIfCustomerGuard],
    children: [
      {
        path: "**",
        component: LandingPageComponent
      }
    ]
  },
  {
    path: "inmatch-app",
    resolve: {
      user: UserResolver
    },
    children: [
      {
        path: "**",
        component: PageRecsComponent
      }
    ]
  },
  {
    path: "invoices",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms, PreloadRelationships],
    children: [
      {
        path: "**",
        component: PageInvoiceComponent
      }
    ]
  },
  {
    path: "digitization",
    component: PortalShellComponent,
    // canActivate: [AuthGuard, AgreedToTerms],
    resolve: {
      user: UserResolver
    },
    children: [
      {
        path: "**",
        component: DigitizationRootComponent
      }
    ]
  },
  {
    path: "digitization-app",
    resolve: {
      user: UserResolver
    },
    children: [
      {
        path: "**",
        component: DigitizationRootComponent
      }
    ]
  },
  {
    path: "incash",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms, PreloadRelationships],
    children: [
      {
        path: "**",
        component: PageIncashComponent
      }
    ]
  },
  {
    path: "relationships",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms, PreloadRelationships],
    children: [
      {
        path: "**",
        component: PageRelationshipsComponent
      }
    ]
  },
  {
    path: "companies",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms],
    children: [
      {
        path: "**",
        component: PageCompaniesComponent
      }
    ]
  },
  {
    path: "userPermissions",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms],
    children: [
      {
        path: "**",
        component: PageUserPermissionsComponent
      }
    ]
  },
  {
    path: "profile",
    component: PortalShellComponent,
    canActivate: [AuthGuard, MustBeDistributor, UserCanAdmin, AgreedToTerms],
    children: [
      {
        path: "",
        component: ProfileShellComponent,
        children: [
          {
            path: "",
            component: ProfileShellProfileTabComponent
          }
        ]
      }
    ]
  },
  {
    path: "profile/users",
    component: PortalShellComponent,
    canActivate: [AuthGuard, UserCanAdmin, AgreedToTerms],
    children: [
      {
        path: "",
        component: ProfileShellComponent,
        children: [
          {
            path: "",
            component: ProfileShellUsersTabComponent
          }
        ]
      }
    ]
  },
  {
    path: "communications",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms],
    children: [
      {
        path: "**",
        component: PageCommunicationsComponent
      }
    ]
  }, {
    path: "customerProfile",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms],
    children: [
      {
        path: "**",
        component: PageCustomerProfileComponent
      }
    ]
  },
  {
    path: "bi",
    component: PortalShellComponent,
    canActivate: [AuthGuard, AgreedToTerms],
    children: [
      {
        path: "**",
        component: PageBusinessIntelligenceComponent
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
